export const WHITEBOARD_KEYS = {
  all: ['whiteboards'] as const,
  byOrg: (orgId: string) => ['whiteboards', orgId] as const,
  byBoard: (orgId: string, boardId: string) => ['whiteboards', orgId, 'board', boardId] as const,
  detail: (orgId: string, whiteboardId: string) =>
    ['whiteboards', orgId, 'detail', whiteboardId] as const,
};
